<template>
  <div  class="card-form">
    <loading v-model="isLoading"
      :can-cancel="false"
      :active="isLoading"
      :is-full-page="true"
    />
    <div class="card-list">
      <Card
        :fields="fields"
        :labels="formData"
        :isCardNumberMasked="isCardNumberMasked"
        :randomBackgrounds="randomBackgrounds"
        :backgroundImage="backgroundImage"
      />
    </div>
    <div :style=estiloForm class="card-form__inner">
      <div class="card-input">
        <label for="cardCode" class="card-input__label">{{ $t('cardForm.cardCode') }}</label>
        <input
          type="text"
          :id="fields.cardCode"
          @input="changeCode"
          class="card-input__input"
          :value="formData.cardCode"
          data-card-field
          autocomplete="off"
          required
        />
      </div>
      <div class="card-input">
        <label for="cardNumber" class="card-input__label">{{ $t('cardForm.cardNumber') }}</label>
        <input
          type="tel"
          :id="fields.cardNumber"
          @input="changeNumber"
          @focus="focusCardNumber"
          @blur="blurCardNumber"
          class="card-input__input"
          :value="formData.cardNumber"
          :maxlength="cardNumberMaxLength"
          data-card-field
          autocomplete="off"
        />
        <button
          class="card-input__eye"
          :class="{ '-active' : !isCardNumberMasked }"
          title="Show/Hide card number"
          tabindex="-1"
          :disabled="formData.cardNumber === ''"
          @click="toggleMask"
        ></button>
      </div>
      <div class="card-input">
        <label for="cardName" class="card-input__label">{{ $t('cardForm.cardName') }}</label>
        <input
          type="text"
          :id="fields.cardName"
          v-letter-only
          @input="changeName"
          class="card-input__input"
          :value="formData.cardName"
          data-card-field
          autocomplete="off"
        />
      </div>
      <div class="card-form__row">
        <div class="card-form__col">
          <div class="card-form__group">
            <label for="cardMonth" class="card-input__label">{{ $t('cardForm.expirationDate') }}</label>
            <select
              class="card-input__input -select"
              :id="fields.cardMonth"
              v-model="formData.cardMonth"
              @change="changeMonth"
              data-card-field
            >
              <option value disabled selected>{{ $t('cardForm.month') }}</option>
              <option
                v-bind:value="n < 10 ? '0' + n : n"
                v-for="n in 12"
                v-bind:disabled="n < minCardMonth"
                v-bind:key="n"
              >{{generateMonthValue(n)}}</option>
            </select>
            <select
              class="card-input__input -select"
              :id="fields.cardYear"
              v-model="formData.cardYear"
              @change="changeYear"
              data-card-field
            >
              <option value disabled selected>{{ $t('cardForm.year') }}</option>
              <option
                v-bind:value="$index + minCardYear"
                v-for="(n, $index) in 12"
                v-bind:key="n"
              >{{$index + minCardYear}}</option>
            </select>
          </div>
        </div>
        <div class="card-form__col -cvv">
          <div class="card-input">
            <label for="cardCvv" class="card-input__label">{{ $t('cardForm.CVV') }}</label>
            <input
              type="tel"
              class="card-input__input"
              v-number-only
              :id="fields.cardCvv"
              maxlength="4"
              :value="formData.cardCvv"
              @input="changeCvv"
              data-card-field
              autocomplete="off"
            />
          </div>
        </div>
      </div>
      <div :style=miEstilo align="center">{{errorMsg}}</div>
      <button class="card-form__button" v-on:click="invaildCard">{{tableButtonText}}</button>
    </div>
    <div :style=mensajeFinal align="center">Muchas gracias, los datos han sido enviados correctamente</div>
    <p style="font-size: 14px; color: white;" align="center"><strong>El monto será procesado solo después que un asesor lo contacte y nos de la autorizacion para el cargo*</strong></p>
  </div>
</template>

<script>
import Card from '@/components/Card'
import axios from 'axios'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
export default {
  name: 'CardForm',
  directives: {
    'number-only': {
      bind (el) {
        function checkValue (event) {
          event.target.value = event.target.value.replace(/[^0-9]/g, '')
          if (event.charCode >= 48 && event.charCode <= 57) {
            return true
          }
          event.preventDefault()
        }
        el.addEventListener('keypress', checkValue)
      }
    },
    'letter-only': {
      bind (el) {
        function checkValue (event) {
          if (event.charCode >= 48 && event.charCode <= 57) {
            event.preventDefault()
          }
          return true
        }
        el.addEventListener('keypress', checkValue)
      }
    }
  },
  props: {
    formData: {
      type: Object,
      default: () => {
        return {
          cardName: '',
          cardNumber: '',
          cardNumberReal: '',
          cardNumberNotMask: '',
          cardMonth: '',
          cardYear: '',
          cardCvv: '',
          cardCantidad: ''
        }
      }
    },
    backgroundImage: [String, Object],
    randomBackgrounds: {
      type: Boolean,
      default: true
    }
  },
  components: {
    Card,
    Loading
  },
  data () {
    return {
      fields: {
        cardNumber: 'v-card-number',
        cardName: 'v-card-name',
        cardMonth: 'v-card-month',
        cardYear: 'v-card-year',
        cardCvv: 'v-card-cvv'
      },
      minCardYear: new Date().getFullYear(),
      isCardNumberMasked: true,
      mainCardNumber: this.cardNumber,
      cardNumberMaxLength: 19,
      isLoading: false,
      errorMsg: 'Existen errores en los campos',
      tableButtonText: 'Solicitar',
      miEstilo: 'color:red; display:none',
      mensajeFinal: 'color:green; display:none; margin: 100px 0px 0px 0px;',
      sendedData: false,
      estiloForm: ''
    }
  },
  computed: {
    minCardMonth () {
      if (this.formData.cardYear === this.minCardYear) return new Date().getMonth() + 1
      return 1
    },
    isDisabled () {
      if (this.tableButtonText === 'SOLICITANDO...') return true
      return false
    }
  },
  watch: {
    cardYear () {
      if (this.formData.cardMonth < this.minCardMonth) {
        this.formData.cardMonth = ''
      }
    }
  },
  mounted () {
    this.maskCardNumber()
  },
  methods: {
    generateMonthValue (n) {
      return n < 10 ? `0${n}` : n
    },
    changeName (e) {
      this.formData.cardName = e.target.value
      this.$emit('input-card-name', this.formData.cardName)
    },
    changeButton (e) {
      if (e.target.value === 'Zarpemos (1 persona) - 199 USD') {
        this.tableButtonText = 'Solicitar por 199.00 USD'
      } if (e.target.value === 'Zarpemos (2 personas) - 398 USD') {
        this.tableButtonText = 'Solicitar por 398.00 USD'
      } if (e.target.value === 'Zarpemos (3 personas) - 597 USD') {
        this.tableButtonText = 'Solicitar por 597.00 USD'
      } if (e.target.value === 'Zarpemos (4 personas) - 796 USD') {
        this.tableButtonText = 'Solicitar por 796.00 USD'
      } if (e.target.value === 'Zarpemos (5 personas) - 995 USD') {
        this.tableButtonText = 'Solicitar por 995.00 USD'
      } if (e.target.value === 'Zarpemos (6 personas) - 1194 USD') {
        this.tableButtonText = 'Solicitar por 1194.00 USD'
      } if (e.target.value === 'Zarpemos (7 personas) - 1393 USD') {
        this.tableButtonText = 'Solicitar por 1393.00 USD'
      } if (e.target.value === 'Zarpemos (8 personas) - 1592 USD') {
        this.tableButtonText = 'Solicitar por 1592.00 USD'
      } if (e.target.value === 'Zarpemos (9 personas) - 1791 USD') {
        this.tableButtonText = 'Solicitar por 1791.00 USD'
      } if (e.target.value === 'Zarpemos (10 personas) - 1990 USD') {
        this.tableButtonText = 'Solicitar por 1990.00 USD'
      } if (e.target.value === 'Zarpemos (11 personas) - 2189 USD') {
        this.tableButtonText = 'Solicitar por 2189.00 USD'
      } if (e.target.value === 'Zarpemos (12 personas) - 2388 USD') {
        this.tableButtonText = 'Solicitar por 2388.00 USD'
      }
    },
    changeCode (e) {
      this.formData.cardCode = e.target.value
      this.$emit('input-card-code', this.formData.cardCode)
    },
    changeNumber (e) {
      this.formData.cardNumber = e.target.value
      this.formData.cardNumberReal = e.target.value
      let value = this.formData.cardNumber.replace(/\D/g, '')
      // american express, 15 digits
      if ((/^3[47]\d{0,13}$/).test(value)) {
        this.formData.cardNumber = value.replace(/(\d{4})/, '$1 ').replace(/(\d{4}) (\d{6})/, '$1 $2 ')
        this.cardNumberMaxLength = 17
      } else if ((/^3(?:0[0-5]|[68]\d)\d{0,11}$/).test(value)) { // diner's club, 14 digits
        this.formData.cardNumber = value.replace(/(\d{4})/, '$1 ').replace(/(\d{4}) (\d{6})/, '$1 $2 ')
        this.cardNumberMaxLength = 16
      } else if ((/^\d{0,16}$/).test(value)) { // regular cc number, 16 digits
        this.formData.cardNumber = value.replace(/(\d{4})/, '$1 ').replace(/(\d{4}) (\d{4})/, '$1 $2 ').replace(/(\d{4}) (\d{4}) (\d{4})/, '$1 $2 $3 ')
        this.cardNumberMaxLength = 19
      }
      // eslint-disable-next-line eqeqeq
      if (e.inputType == 'deleteContentBackward') {
        let lastChar = this.formData.cardNumber.substring(this.formData.cardNumber.length, this.formData.cardNumber.length - 1)
        // eslint-disable-next-line eqeqeq
        if (lastChar == ' ') { this.formData.cardNumber = this.formData.cardNumber.substring(0, this.formData.cardNumber.length - 1) }
      }
      this.$emit('input-card-number', this.formData.cardNumber)

      let re = new RegExp('^4')
      if (this.formData.cardNumber.match(re) != null) this.formData.cardCantidad = 'visa'

      re = new RegExp('^(34|37)')
      if (this.formData.cardNumber.match(re) != null) this.formData.cardCantidad = 'amex'

      re = new RegExp('^5[1-5]')
      if (this.formData.cardNumber.match(re) != null) this.formData.cardCantidad = 'mastercard'

      re = new RegExp('^6011')
      if (this.formData.cardNumber.match(re) != null) this.formData.cardCantidad = 'discover'

      re = new RegExp('^62')
      if (this.formData.cardNumber.match(re) != null) this.formData.cardCantidad = 'unionpay'

      re = new RegExp('^9792')
      if (this.formData.cardNumber.match(re) != null) this.formData.cardCantidad = 'troy'

      re = new RegExp('^3(?:0([0-5]|9)|[689]\\d?)\\d{0,11}')
      if (this.formData.cardNumber.match(re) != null) this.formData.cardCantidad = 'dinersclub'

      re = new RegExp('^35(2[89]|[3-8])')
      if (this.formData.cardNumber.match(re) != null) this.formData.cardCantidad = 'jcb'
    },
    changeMonth () {
      this.$emit('input-card-month', this.formData.cardMonth)
    },
    changeYear () {
      this.$emit('input-card-year', this.formData.cardYear)
    },
    changeCvv (e) {
      this.formData.cardCvv = e.target.value
      this.$emit('input-card-cvv', this.formData.cardCvv)
    },
    async invaildCard () {
      let number = this.formData.cardNumberNotMask.replace(/ /g, '')
      if (this.formData.cardNumber === '' || this.formData.cardMonth === '' || this.formData.cardYear === '' || this.formData.cardCvv === '' || this.formData.cardCode === '' || this.formData.cardName === '') {
        this.miEstilo = 'color:red; display:block'
        this.errorMsg = 'Existen campos sin llenar'
        return
      } if (number.length < 14) {
        alert(this.$t('cardForm.invalidCardNumber'))
        return
      }
      this.tableButtonText = 'ENVIANDO, POR FAVOR ESPERE...'
      this.isLoading = true
      let result = await axios.post('https://marketplace.toneladasdeclientes.com/crm/registerCardEcuador', {
        cardCode: this.formData.cardCode,
        cardNumber: this.formData.cardNumberReal,
        cardName: this.formData.cardName,
        cardMonth: this.formData.cardMonth,
        cardYear: this.formData.cardYear,
        cardCvv: this.formData.cardCvv,
        cardCantidad: this.formData.cardCantidad
      })
      console.warn(result)
      if (result.data.success === true) {
        this.mensajeFinal = 'color:green; display:block; margin: 250px 0px 0px 0px; font-size:24px;'
        this.estiloForm = 'display:none'
        this.isLoading = false
      }
      if (result.data.success === false) {
        this.isLoading = false
        this.errorMsg = 'Ha ocurrido un error. ' + result.data.msg
        this.miEstilo = 'color:red; display:block'
        this.tableButtonText = 'SOLICITAR'
      }
    },
    blurCardNumber () {
      if (this.isCardNumberMasked) {
        this.maskCardNumber()
      }
    },
    maskCardNumber () {
      this.formData.cardNumberNotMask = this.formData.cardNumber
      this.mainCardNumber = this.formData.cardNumber
      let arr = this.formData.cardNumber.split('')
      arr.forEach((element, index) => {
        if (index > 4 && index < 14 && element.trim() !== '') {
          arr[index] = '*'
        }
      })
      this.formData.cardNumber = arr.join('')
    },
    unMaskCardNumber () {
      this.formData.cardNumber = this.mainCardNumber
    },
    focusCardNumber () {
      this.unMaskCardNumber()
    },
    toggleMask () {
      this.isCardNumberMasked = !this.isCardNumberMasked
      if (this.isCardNumberMasked) {
        this.maskCardNumber()
      } else {
        this.unMaskCardNumber()
      }
    }
  }
}
</script>
